import React from 'react'
import { useField, type FormikValues } from 'formik'

import { TtTextField } from '@23/react'

import type {
  FieldNameMatchingAcceptedType,
  FormikFormControlProps,
} from './index'

const TtTextFieldFormik = <FV extends FormikValues>({
  name,
  validate,
  invalid,
  errorText,
  ...props
}: FormikFormControlProps<'tt-text-field'> & {
  name: FieldNameMatchingAcceptedType<
    FV,
    HTMLTtTextFieldElement['value'] | undefined
  >
}) => {
  const [field, meta] = useField<HTMLTtTextFieldElement['value']>({
    name,
    type: 'text',
    validate,
  })

  return (
    <TtTextField
      {...props}
      name={field.name}
      value={field.value}
      onBlur={field.onBlur}
      onTt-change={field.onChange}
      onTt-input={field.onChange}
      invalid={meta.touched && (!!meta.error || invalid)}
      errorText={meta.error ?? errorText}
    />
  )
}

export { TtTextFieldFormik }
